import {
  GET_COUPONS,
  FETCH_START,
  FETCH_SUCCESS,
  FETCH_ERROR,
  SET_PAGE,
  SET_SEARCH,
  SHOW_MESSAGE,
  SET_ORDER_BY,
  SET_SORT_BY,
  GET_COUPON_PRODUCTS,
  GET_PRODUCTS_CATEGORY,
} from "../../shared/constants/ActionTypes";

import jwtAxios from "@crema/services/auth/jwt-auth/jwt-api";

export const getCoupons = () => {
  return (dispatch, getState) => {
    const state = getState().coupons;
    dispatch({ type: FETCH_START });
    jwtAxios
      .post("/coupon/list", {
        search: state.search,
        page: state.page,
        limit: 10,
        orderby: state.orderby,
        sortby: state.sortby,
      })
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: GET_COUPONS,
            payload: data.data.data,
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const addCoupons = (payload) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .post("/coupon/add", payload)
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: SHOW_MESSAGE,
            payload: "Coupon added successfully",
          });
          dispatch(getCoupons());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const editCoupons = (payload) => {
  return (dispatch) => {
    console.log({ payload });
    dispatch({ type: FETCH_START });
    jwtAxios
      .post("/coupon/edit", payload)
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: SHOW_MESSAGE,
            payload: "Coupon updated successfully",
          });
          dispatch(getCoupons());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const deleteCoupons = (payload) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .post("/coupon/delete", payload)
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: SHOW_MESSAGE,
            payload: "Coupon deleted successfully",
          });
          dispatch(getCoupons());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const uploadBulkCoupons = (payload) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .post("/coupon/bulk-add", payload)
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: SHOW_MESSAGE,
            payload: "Coupon added successfully",
          });
          dispatch(getCoupons());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const getAllProducts = (payload) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .post("/coupon/getAllProducts", payload)
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: GET_COUPON_PRODUCTS,
            payload: data.data.data,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const getAllCategory = (payload) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .get("/coupon/getAllCategories")
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: GET_PRODUCTS_CATEGORY,
            payload: data.data.data,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const setPage = (page) => {
  return (dispatch) => {
    dispatch({ type: SET_PAGE, payload: page });
  };
};

export const setSearch = (search) => {
  return (dispatch) => {
    dispatch({ type: SET_SEARCH, payload: search });
  };
};
export const setOrderBy = (orderby) => {
  return (dispatch) => {
    dispatch({ type: SET_ORDER_BY, payload: orderby });
  };
};
export const setSortBy = (sortby) => {
  return (dispatch) => {
    dispatch({ type: SET_SORT_BY, payload: sortby });
  };
};
